<template>
  <div id="app" v-wechat-title="$route.meta.title">
    <pubHeaderNew ref="pubHeaderNew"></pubHeaderNew>
    <section class="hd-cont">
      <div class="hd-carousel">
        <el-carousel indicator-position="always"  arrow='always'>
          <el-carousel-item  name='carouPro'>
            <div class="hd-carousel-cont img1">
              <h3 class="hd-carousel-h3">匠心打造网络货运供应链</h3>
              <h2 class="hd-carousel-h2">务实笃行 大志有成</h2>
            </div>
          </el-carousel-item>
          <el-carousel-item  name='carouPro'>
            <div class="hd-carousel-cont img2">
              <h3 class="hd-carousel-h3">大宗商品信息发布平台 </h3>
              <h2 class="hd-carousel-h2">激昂奋进 大道易行</h2>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="hd-hall hd-hall-sour">
        <div class="hd-sour">
          <div class="hd-sour-tl clearfix">
            <h3 class="hd-sour-h3">货源信息</h3>
            <a class="hd-sour-a" target="_blank" href="/hall.html#/0">更多 ></a>
          </div>
          <ul class="hd-sour-ul clearfix">
            <li class="hd-sour-li" v-for="(item,ine) in carList" :key="ine">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>{{item.attr_loadAddr}} - {{item.attr_unloadAddr}}</b>
                </div>
                <div class="card_list text item">
                  <div class="card_item"> <span class="card_label">货物名称：</span> {{item.attr_goodsName}} </div>
                  <div class="card_item"> <span class="card_label">装货时间：</span> {{item.attr_unloadTime}} </div>
                  <div class="card_item"> <span class="card_label">运输距离：</span> {{item.attr_distance}} KM </div>
                  <div class="card_item"> <span class="card_label">货物重量：</span> {{item.attr_goodsUnit}} 吨 </div>
                  <div class="card_item"> <span class="card_label">运费单价：</span> {{item.attr_price && item.attr_price !== '面议'?`${item.attr_price} 元/吨`:'面议'}} </div>
                  <div class="card_item"> <span class="card_label">联系人：</span> {{item.attr_contactName}} </div>
                  <div class="card_item"> <span class="card_label">联系电话：</span> {{item.attr_contactPhone}} </div>
                </div>
              </el-card>
            </li>
          </ul>
        </div>
        <div class="hd-sour">
          <div class="hd-sour-tl clearfix">
            <h3 class="hd-sour-h3">车源信息</h3>
            <a class="hd-sour-a" target="_blank" href="/hall.html#/1">更多 ></a>
          </div>
          <ul class="hd-sour-ul clearfix">
            <li class="hd-sour-li" v-for="(item,ine) in goodsList" :key="ine">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>{{item.attr_loadAddr}} - {{item.attr_unloadAddr}}</b>
                </div>
                <div class="card_list text item">
                  <div class="card_item"> <span class="card_label">车型/车长: </span> {{item.attr_carModel}} / {{item.attr_carLenght}}米 </div>
                  <div class="card_item"> <span class="card_label">空车时间：</span> {{item.attr_noUseTime}} </div>
                  <div class="card_item"> <span class="card_label">满载吨位：</span> {{item.attr_maxLoad}} 吨 </div>
                  <div class="card_item"> <span class="card_label">车辆牌照：</span> {{item.attr_carCode}} </div>
                  <div class="card_item"> <span class="card_label">运费单价：</span> {{item.attr_price && item.attr_price !== '面议'?`${item.attr_price} 元/吨`:'面议'}} </div>
                  <div class="card_item"> <span class="card_label">联系人：</span> {{item.attr_contactName}} </div>
                  <div class="card_item"> <span class="card_label">联系电话：</span> {{item.attr_contactPhone}} </div>
                  <div class="card_item"> <span class="card_label">成单次数：</span> {{item.attr_orderNum}}单 </div>
                </div>
              </el-card>
            </li>
          </ul>
        </div>
      </div>
      <div class="hd-hall">
        <div class="hd-sour">
          <div class="hd-sour-tl clearfix">
            <h3 class="hd-sour-h3">企业资讯</h3>
          </div>
            <div class="big-news">
              <div class="newslist clearfix" v-loading="newsStatus" ref="newslist">

                <div class="list-item"  @click="newsDetail(index,item)"  v-for="(item,index) in showList" :key="index">
                  <div class="gr-dynamic-img" :style="`background-image:url(${host+item.picArr[0].picPaths})`">
                    <!-- <img :src="host+item.picArr[0].picPaths" alt="item.title"> -->
                  </div>
                  <div class="item-info">
                    <p class="news-title">{{item.title}}</p>
                    <p class="news-date">{{item.releaseDate|formatDate}}</p>
                    <div class="news-text">
                      {{item.desc}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="hd-hall hd-hall-map">
        <div class="contact">
          <div class="first-title">
            <img src="../../../static/img/lianxi_women.svg" alt="">

          </div>
          <div class="mapbox clearfix">
            <div class="map fl" id="allmap">
            </div>
            <div class="address fl">
              <p class="add-label">
                <img src="../../../static/img/gongsi_dizhi.svg" alt="">
              </p>
              <div class="add-inline" style="height:90px">
                <p class="first-line clearfix"><img src="../../../static/image/ic_tomap.png" alt=""><img src="../../../static/img/dizhi2.svg" alt=""></p>
              
              </div>
              <p class="add-label">
                <img src="../../../static/img/youbian.svg" alt="">
              </p>
              <div class="add-inline">
                <p class="first-line"><img src="../../../static/image/youxiang.png" alt="">047699</p>

              </div>
              <p class="add-label">
                <img src="../../../static/img/fuwu_dianhua.svg" alt="">
              </p>
              <div class="add-inline">
                <p class="first-line"><img src="../../../static/image/dianhua.png" alt="">400-056-1156</p>
                <p></p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <pubFooter></pubFooter>
  </section>
  </div>
</template>

<script>
import { gb2big5 } from '@/utils/gb2big5.js'
import { formatDate } from '@/utils/date.js'
export default {
  name: "App",
  data() {
    return {
      isCollapse: false,
      carList:[],
      goodsList:[],
      showList:[],
      newsStatus:false,
      carStatus:false,
      goodsStatus:false,
      host:this.API.host,
      editableTabs: [{
        // title: '全国货源信息',
        channelIds: '112',
        first: 0,
        count:4,
        format:0
      }, {
        // title: '全国车源信息',
        channelIds: '111',
        first: 0,
        count:4,
        format:0
      }],
      news:{
        // title: '新闻',
        channelIds: '75',
        first: 0,
        count:4,
        format:0
      },
    };
  },
  methods: {
    newsDetail(id,item){
      
      // if(id=='dynamic'){
      //   location.href='/news.html#/newsDetail/133/'+item.id
      // }else{
      //   location.href='/news.html#/newsDetail/139/'+item.id
      // }
      location.href='/newsDetail.html#/'+item.id
    },
    videoPlay(){
      
    },
    setMap(){
        // console.log(document.getElementById('allmap').clientWidth,document.getElementById('allmap').clientHeight);
        // 百度地图API功能
        var map = new BMap.Map("allmap");    // 创建Map实例
        // map.centerAndZoom(new BMap.Point(113.724459,34.768959), 12); // 初始化地图,设置中心点坐标和地图级别
        map.centerAndZoom(new BMap.Point(129.91433051857882,46.734283245993694), 18); // 初始化地图,设置中心点坐标和地图级别
        map.setCurrentCity("黑龙江");
        // map.enableScrollWheelZoom(false); // 鼠标滚动缩放
        // map.addControl(new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT}));// 左上角，添加比例尺
        // map.addControl(new BMap.NavigationControl());  //左上角，添加默认缩放平移控件
        // var myIcon = new BMap.Icon(
        //   "../../../../static/intergrated_img/images/ioc-map.png",
        //   new BMap.Size(24, 25),
        //   {
        //     anchor: new BMap.Size(12, 25) //标注图片偏移量
        //   }
        // );
        var marker = new BMap.Marker(new BMap.Point(129.91433051857882,46.734283245993694),
        // {
        //   icon: myIcon
        // }
        );
        map.addOverlay(marker); // 将标注添加到地图中
      },
    getChana(list){
      // console.log(list)
      let data = '';
      for(let i =0;i<list.length;i++){
        if(/[\u4E00-\u9FA5\uF900-\uFA2D]/.test(list[i])){
          data = list[i]
          break
        }
      }
      return data
    },
    async getNewsData(){
      this.newsStatus= true
       let matchReg = />.*?\<\/p/gi;
      let newsData = await this.API.line.contentList(this.news)
      
      this.showList = !!newsData?newsData.body:[]
      this.showList.forEach(ele=>{
        ele.picArr.length==0?ele.picArr[0]={}:'';
        let it= this.getChana(ele.txt.match(matchReg))
        ele.desc = ele.txt.replace(/<[^>]+>/g,"").replace(/&nbsp;/g,'')
      })
      this.newsStatus = false
    },
    async getCarData(){
      this.carStatus = true
      let carData = await this.API.line.contentList(this.editableTabs[0])
      this.carList = !!carData?carData.body:[]
      this.carStatus = false
    },
    async getGoodsData(){
      this.goodsStatus = true
      let goodsData = await this.API.line.contentList(this.editableTabs[1])
      this.goodsList = !!goodsData?goodsData.body:[]
      this.goodsStatus = false
    },
  },
  filters: {
      // formatDate (time) {
      //     var date = new Date(time)
      //     console.log(time,formatDate(date, 'yyyy/MM/dd'))
      //     return formatDate(date, 'yyyy/MM/dd')
      // }
      formatDate(value){
          return moment(value).format('YYYY-MM-DD')
      }
  },
  mounted() {
    // gb2big5();
    // location.href='/hall.html'
    let vue = this
      setTimeout(() => {
          vue.setMap()
      }, 1000);
    this.$refs.pubHeaderNew.changeHeard(-1)
    this.getCarData()
    this.getNewsData()
    this.getGoodsData()
    
  },
  updated() {},
  created() {}
};
</script>
<style>
.hd-cont .el-carousel__arrow--right{
  right: 50px;
}
.hd-cont .el-carousel__arrow--left{
  left: 50px;
}
.hd-cont .el-carousel__arrow{
      height: 80px;
    width: 80px;
    font-size: 54px;
    background-color: rgba(31,45,61,.2);
}
.hd-sour .el-card__header {
    border: 0;
    padding-bottom: 0;
    padding-top: 24px;
    font-size: 16px;
    font-family: MicrosoftYaHeiSemibold;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
    height: 64px;
}
</style>

<style scoped>
@import url("../../assets/reset.css");
/* @import url("../../../static/css/animate.min.css"); */
#app {
  height: 100%;
}
.filterConArea{
  height: 100%;
}
.hd-cont{
  position: relative;
  width: 100%;
  margin-top: 120px;
  background-color: #f5f5f5;
}
.hd-carousel{
  height: auto;
  width: 1260px !important;
  margin: 0 auto;
  /* background-color: #999999; */
  position: relative;
  padding-top: 30px;
}
.hd-hall{
 height: auto;
  width: 1260px !important;
  margin: 40px auto;
  /* background-color: #fff; */
  padding-top: 40px;
  /* overflow: hidden; */
  border-radius: 10px;
  
}
.hd-cont{
  background-image: url('../../../static/img/keji_bk.png');
  background-position: top;
 /* background-repeat: no-repeat; */
 background-size: auto 100% ;
}
.hd-sour{
 padding-bottom: 40px;
  position: relative;
  
}
.hd-carousel-cont{
 height: 360px;
 background-position: center;
 background-repeat: no-repeat;
 background-size: auto 100% ;
 background-color: rgba(245,245,245,1);

}
.hd-carousel-cont.img1{
  background-image: url('../../../static/img/big_img1@2x.png');
}
.hd-carousel-cont.img2{
  background-image: url('../../../static/img/big_img2@2x.png');
}
.hd-sour-ul{
  height: 325px;
  margin-top: 20px;
}
.hd-sour-li{
  width: 300px !important;
    background: rgba(255,255,255,1);
    -webkit-box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 3%);
    box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 3%);
    border-radius: 8px;
    margin: 10px;
    float: left;
    height: auto;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    /* min-height: 293px; */
}
.hd-sour-li:nth-child(1){
  margin-left: 0;
}
.hd-sour-li:last-child{
  margin-right: 0;
}
.hd-sour-li .box-card{
  min-height: 300px;
  border-radius: 8px;
  overflow: hidden;
}
.hd-sour-li 
.hd-sour .box-card .card_label {
    width: 80px;
    display: inline-block;
    color: rgba(153,153,153,1);
}
.hd-sour .box-card .card_item {
    line-height: 2;
}
.hd-sour-tl{
  margin-bottom: 10px;
  position: relative;
  padding-left: 13px;
}
.hd-sour-tl .hd-sour-h3{
  /* float: left; */
  text-align: center;
  font-size: 24px;
}
.hd-sour-tl .hd-sour-a{
  display: block;
  position: absolute;
  right: 23px;
  bottom: 0;
  color: #0066ff;
  font-size: 16px;
  /* text-decoration-line: underline; */
}
.hd-sour-tl .hd-sour-a:hover{
  text-decoration-line: underline;
}
.big-news {
    width: 100%;
    margin-top: 34px;
    height: 416px;
    /* overflow: hidden; */
    position: relative;
}
.newslist {
    width: 10000%;
    /* left: 10%; */
    position: absolute;
    top: 0;
}
.list-item {
    background: #fff;
    border-radius: 8px;
    width: 300px;
    height: 400px;
    padding: 16px 16px 26px 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    float: left;
    margin-right: 20px;
    border: 4px solid transparent;
    -webkit-box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 3%);
    box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 3%);
    margin-bottom: 40px;
    display: block;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.list-item:hover{
    border: 4px solid #0066FF;
  }
.gr-dynamic-img{
    width: 260px;
    overflow: hidden;
    height: 180px;
    background-position: center;
    background-size: auto 100%;
    -webkit-transition: background-size 0.3s;
    transition: background-size 0.3s;
}
.news-title {
    font-weight: bold;
    color: rgba(0,0,0,.85);
    font-size: 16px;
    line-height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 12px 0;
}
.news-date{
    font-size: 12px;
    color: #999;
    line-height: 15px;
    margin-bottom: 9px;
}
.news-text {
    font-size: 14px;
    line-height: 24px;
    color: #999;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
}
.list-item:hover .gr-dynamic-img{
  /* background-size: auto 120%; */
  /* animation: dynamicimgbig 0.3s; */
  background-size: auto 120%;
}
.contact{
    height: 90%;
    position: absolute;
    /* top: 20%; */
    width: 100%;
    /* left: 10%; */
  }
  /*.mapbox{*/
  /*  margin-top: 7%;*/
  /*  height: 80%;*/
  /*}*/
  .mapbox{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 80%;
  }
  .map{
    display: block;
    width: 61.905%;
    height: 100%;
    border-radius: 10px;
    background: #6D7278;
    overflow: hidden;
    float: left;
    box-shadow: 0 10px 30px #e0e0e0;
  }
  .address{
    display: block;
    /* padding: 50px 0 0 100px; */
    /* width: 30%; */
    float: right;
    text-align: left;
  }
  .add-label{
    font-size: 16px;
    color: #333;
    line-height: 21px;
    font-weight: bold;
  }
  .add-inline{
    margin: 16px 0 32px 0;
    border-bottom: 1px solid rgba(0,0,0,.1);
    font-size: 20px;
    color: #333;
    font-weight: bold;
    line-height: 24px;
    width: 100%;
    height: 60px;
  }
  .first-line{
    font-weight: normal;
  }
  .first-line img{
    margin-right: 14px;
    vertical-align: middle;
    display: block;
    float: left;
  }
  .second-line{
    text-indent: 34px;
  }
  .hd-hall-map{
    position: relative;
    height: 546px;
  }
  .first-title{
    text-align: center;
  }
  .hd-carousel-h3{
    text-align: center;
    padding-top: 100px;
    font-size: 60px;
    font-family: MicrosoftYaHeiSemibold, MicrosoftYaHeiSemibold-Regular;
    font-weight: 400;
    color: #ffffff;
    line-height: 80px;
    padding-bottom: 10px;
  }
  .hd-carousel-h2{
    text-align: center;
    font-size: 18px;
    font-family: MicrosoftYaHeiSemibold, MicrosoftYaHeiSemibold-Regular;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    border: 2px solid #ffffff;
    border-radius: 25px;
    padding: 10px 40px;
    width: 165px;
height: 24px;
    margin:0 auto;
    
  }
</style>
